import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Download from 'assets/download-chart.svg';
import { Table } from '../components/Table';
import { Dropdown } from '../components/Dropdown';
import { StatementDownload } from '../shared/types';
import { Column } from 'components/Analytics/types';

interface StatementTableProps {
    statements: StatementDownload[];
    period: string;
    onPeriodChange: (value: string) => void;
}

const statementColumns: Column[] = [
    {
        title: 'Statement',
        render: (data: StatementDownload) => `${data.month} ${data.year}`,
        flex: '1',
    },
    {
        title: 'Amount Due',
        render: (data: StatementDownload) => (
            <AmountCell>
                <span>${data.amount.toFixed(2)}</span>
                <DownloadIcon />
            </AmountCell>
        ),
        width: '200px',
    },
];

export const StatementTable: React.FC<StatementTableProps> = ({
    statements,
    period,
    onPeriodChange,
}) => {
    return (
        <Container>
            <Header>
                <Title>
                    <FormattedMessage
                        id="Finance.Statement.Downloads"
                        defaultMessage="Statement Downloads"
                    />
                </Title>
                <Dropdown
                    options={[
                        { label: 'Last 6 months', value: 'Last 6 months' },
                        { label: 'Last 12 months', value: 'Last 12 months' },
                        { label: 'This year', value: 'This year' },
                        { label: 'All time', value: 'All time' },
                    ]}
                    onChange={onPeriodChange}
                    initialValue={period}
                />
            </Header>
            <Table
                columns={statementColumns}
                data={statements}
                initialRows={6}
            />
        </Container>
    );
};

const Container = styled.div`
    width: 100%;

    @media (max-width: 768px) {
        margin-top: 8px;
    }
`;

const Header = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    gap: 12px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }
`;

const Title = styled.div`
    font-size: 18px;
    font-weight: 600;
    color: #000000;

    @media (max-width: 768px) {
        font-size: 16px;
    }
`;

const AmountCell = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 8px;

    span {
        font-weight: 500;
    }
`;

const DownloadIcon = styled(Download)`
    width: 20px;
    height: 20px;
    cursor: pointer;
    opacity: 0.6;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 1;
    }

    @media (max-width: 768px) {
        width: 18px;
        height: 18px;
    }
`;
